import { useTranslation } from "@opendash/core";
import { stringToTag } from "@opendash/ui";
import { Divider, Flex, Timeline, TimelineItemProps, Typography } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketContext } from "../../_shared/context/TicketContext";
const { Text } = Typography;
/**
 * @description: Renders events of a ticket as timeline.
 */
export default observer((props: { showdivider: boolean }) => {
  const t = useTranslation();
  const { messages } = React.useContext(TicketContext);

  const items: TimelineItemProps[] =
    messages
      ?.slice()
      ?.sort((a, b) =>
        dayjs(a.get("displayAt")).isAfter(dayjs(b.get("displayAt"))) ? -1 : 1
      )
      .map((msg) => ({
        label: dayjs(msg.displayAt ?? msg.createdAt).format(
          "DD.MM.YYYY @ HH:mm:ss"
        ),
        children: (
          <Flex vertical>
            <Text strong>
              {stringToTag(
                t(msg.get("title"), msg.get("data")?.translation),
                "'"
              )}
            </Text>
            <Text>
              {stringToTag(
                t(msg.get("content"), msg.get("data")?.translation),
                "'"
              )}
            </Text>
          </Flex>
        ),
        key: msg.id,
      })) ?? [];

  return (
    <>
      {props.showdivider && (
        <Divider orientation="left" style={{ marginTop: 150 }}>
          {t("maintenance:ticket.eventtimeline.headline")}
        </Divider>
      )}
      <Timeline mode="left" items={items} />
    </>
  );
});
